import React from 'react'
import {Map} from 'immutable'
import {connect} from 'react-redux'

import MaskedInput from 'react-maskedinput'
import Spinner from 'react-spinkit'

import {
  PAYOUT_REQUEST_STATUSES
} from '../shared/config/constants'

import fullPath from '../shared/data/helpers/full_path'
import sendPayoutRequest from '../shared/data/setters/send_payout_request'
// import sendPayoutRequestForLater from '../shared/data/setters/send_payout_request_for_later_session'
import setLaterSessionSideEffects from '../shared/data/setters/set_later_session_side_effects'
import setImmediateSessionSideEffects from '../shared/data/setters/set_immediate_session_side_effects'
import {watchCurrentPayoutRequest, unwatchCurrentPayoutRequest} from '../shared/data/watchers/current_payout_request'

class CreditCardForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      currentCard: 'default'
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onSavedCardSubmit = this.onSavedCardSubmit.bind(this)
    this.onSwitchCurrentCard = this.onSwitchCurrentCard.bind(this)
    this.onCardNumChange = this.onCardNumChange.bind(this)
    this.sendPayoutRequest = this.sendPayoutRequest.bind(this)
    this.watchPayoutRequest = this.watchPayoutRequest.bind(this)

    this.cardMonths = [
      {value: 1, label: '01'},
      {value: 2, label: '02'},
      {value: 3, label: '03'},
      {value: 4, label: '04'},
      {value: 5, label: '05'},
      {value: 6, label: '06'},
      {value: 7, label: '07'},
      {value: 8, label: '08'},
      {value: 9, label: '09'},
      {value: 10, label: '10'},
      {value: 11, label: '11'},
      {value: 12, label: '12'}
    ]

    this.cardYears = [
      {value: 16, label: '16'},
      {value: 17, label: '17'},
      {value: 18, label: '18'},
      {value: 19, label: '19'},
      {value: 20, label: '20'},
      {value: 21, label: '21'},
      {value: 22, label: '22'},
      {value: 23, label: '23'},
      {value: 24, label: '24'},
      {value: 25, label: '25'},
      {value: 26, label: '26'},
      {value: 27, label: '27'},
      {value: 28, label: '28'},
      {value: 29, label: '29'}
    ]

    this.cardBrands = {
      default: {
        ccNum: {
          placeholder: 'Card Number',
          placeholderChar: '*',
          mask: '1111',
          size: '20'
        },
        cvc: {
          placeholder: 'CVC',
          placeholderChar: '*',
          mask: '111',
          size: '3'
        }
      },
      visa: {
        ccNum: {
          placeholder: '**** **** **** ****',
          placeholderChar: '*',
          mask: '1111 1111 1111 1111',
          size: '20',
        },
        cvc: {
          placeholder: 'CVC',
          placeholderChar: '*',
          mask: '111',
          size: '3'
        }
      },
      mastercard: {
        ccNum: {
          placeholder: '**** **** **** ****',
          placeholderChar: '*',
          mask: '1111 1111 1111 1111',
          size: '20'
        },
        cvc: {
          placeholder: 'CVC',
          placeholderChar: '*',
          mask: '111',
          size: '3'
        }
      },
      amex: {
        ccNum: {
          placeholder: '**** ****** *****',
          placeholderChar: '*',
          mask: '1111 111111 11111',
          size: '18'
        },
        cvc: {
          placeholder: 'CVC',
          placeholderChar: '*',
          mask: '1111',
          size: '4'
        }
      }
    }
  }

  componentWillUnmount () {
    if (this.props.currentPayoutRequest) {
      const payoutRequestKey = this.props.currentPayoutRequest.get('key')

      if (payoutRequestKey) {
        this.props.unwatchCurrentPayoutRequest(payoutRequestKey)
      }
    }
  }

  componentWillReceiveProps (nextProps) {
    const {currentPayoutRequest: request} = this.props
    const {currentPayoutRequest: nextRequest} = nextProps

    if (nextRequest && request !== nextRequest) {
      const status = request ? request.get('status') : null
      const nextStatus = nextRequest.get('status')
      const {SUCCESS, PENDING, ERROR} = PAYOUT_REQUEST_STATUSES
      const {type, user, expert, sessionLength, sessionStartTime, sessionId} = nextProps

      if ((status !== SUCCESS && nextStatus === SUCCESS) ||
          (status !== PENDING && nextStatus === PENDING)) {
        if (type) {
          // available types = ['immediate', 'later', 'addMoreTime']
          if (type === 'later') {
            this.props.submitLaterSessionSideEffects(
              user, expert, sessionLength, sessionStartTime, sessionId
            )
          }
          else if (type === 'immediate') {
            this.props.submitImmediateSessionSideEffects(
              user, expert, sessionLength, sessionId
            )
          }
        }

        this.setState({isSubmitting: false, errorMessage: null})

        const {currentPayoutRequest} = nextProps

        this.props.onCheckoutComplete(currentPayoutRequest)
      }
      else if (nextStatus === ERROR) {
        const err = nextRequest.get('err')
        let errorMessage = err ? `Error while trying checkout: ${err.get('message')}` : ''

        this.setState({isSubmitting: false, errorMessage})
      }
    }
  }

  componentDidUpdate (_, prevState) {
    if (prevState.currentCard !== this.state.currentCard) {
      if (this.refs && this.refs.ccNum && this.refs.ccNum.input) {
        const placeholderChar = this.getCardRules(this.state.currentCard)['ccNum']['placeholderChar']
        const cursor = this.state.ccNum ? this.state.ccNum.replace(/[\*|\s]/g, '').length : 0

        this.refs.ccNum.input.focus()
        this.refs.ccNum.input.selectionStart = cursor
        this.refs.ccNum.input.selectionEnd = cursor
      }
    }
  }

  watchPayoutRequest (key) {
    this.props.watchCurrentPayoutRequest(key)
  }

  sendPayoutRequest (card, id, sessionId) {
    const payoutRequestData = Map({
      card, stripeToken: id,
      amount: this.props.amount,
      sessionId,
      user: this.props.user.get('uid'),
      userName: this.props.user.get('name'),
      expert: this.props.expert.get('uid'),
      expertName: this.props.expert.get('name')
    }).toJS()

    this.props.sendPayoutRequest(payoutRequestData)
    .then(this.watchPayoutRequest)
  }

  getCardRules (cardName) {
    return this.cardBrands[cardName] || this.cardBrands['default']
  }

  getCardBrand (ccNum) {
    if (ccNum.match(/^4/) != null) {
      return 'visa'
    }
    else if (ccNum.match(/^(34|37)/)) {
      return 'amex'
    }
    else if (ccNum.match(/^5[1-5]/)) {
      return 'mastercard'
    }
    // we discard discover for now... pattern: /^6011/
    else {
      return 'default'
    }
  }

  onSubmit (e) {
    e.preventDefault()

    this.setState({
      errorMessage: null,
      isSubmitting: true
    })

    Stripe.card.createToken(e.currentTarget, (status, response) => {
      if (status === 200) { // this is success
        this.sendPayoutRequest(response.card, response.id, this.props.sessionId)
      }
      else {
        this.setState({
          errorMessage: response.error.message,
          isSubmitting: false
        })
      }
    })
  }

  onSavedCardSubmit (e) {
    if (e) e.preventDefault()

    this.sendPayoutRequest(this.props.currentCustomer.get('card'), null, this.props.sessionId)
  }

  onSwitchCurrentCard (e) {
    if (e) e.preventDefault()

    this.setState({shouldEnterNewCard: true})
  }

  onCardNumChange (e) {
    const ccNum = e.target.value

    const currentCard = this.getCardBrand(ccNum)

    if (currentCard !== this.state.currentCard) {
      this.setState({currentCard, ccNum})
    }
  }

  renderInformation () {
    if (this.state.errorMessage) {
      return (
        <div className='alert danger'>
          {this.state.errorMessage}
        </div>
      )
    }
  }

  renderActions () {
    if (this.state.isSubmitting) {
      return (
        <div className='form-section'>
          <Spinner type='three-bounce'/>
        </div>
      )
    }
    else {
      return (
        <div className='form-section'>
          <button className={this.props.submitButtonClasses}>Checkout</button>
        </div>
      )
    }
  }

  renderCardForm () {
    const {currentCard} = this.state
    const {ccNum, cvc} = this.getCardRules(currentCard)

    return (
      <form className='credit-card-form form' onSubmit={this.onSubmit}>
        <div style={{marginBottom: 5}}>
          <img src={fullPath('/cc_mastercard.jpg')} style={{marginRight: 5, opacity: (currentCard === 'mastercard' ? 1 : .2)}}/>
          <img src={fullPath('/cc_visa.jpg')} style={{marginRight: 5, opacity: (currentCard === 'visa' ? 1 : .2)}}/>
          <img src={fullPath('/cc_amex.jpg')} style={{opacity: (currentCard === 'amex' ? 1 : .2)}}/>
        </div>
        <div className='primary-line form-group'>
          <MaskedInput
            ref='ccNum'
            className='card-number form-control'
            key={currentCard}
            placeholder={ccNum.placeholder}
            placeholderChar={ccNum.placeholderChar}
            mask={ccNum.mask}
            size={ccNum.size}
            value={this.state.ccNum}
            data-stripe='number'
            onChange={this.onCardNumChange}/>
        </div>
        <div className='secondary-line form-group'>
          <div className='expire-date-group'>
            <select className='expire-date-month form-control' data-stripe='exp_month'>
              <option disabled selected>MM</option>
              {
                this.cardMonths.map((cM) => {
                  return <option value={cM.value}>{cM.label}</option>
                })
              }
            </select>
            <select className='expire-date-year form-control' data-stripe='exp_year'>
              <option disabled selected>YY</option>
              {
                this.cardYears.map((cY) => {
                  return <option value={cY.value}>{cY.label}</option>
                })
              }
            </select>
          </div>
          <MaskedInput
            className='cvc form-control'
            style={{width: (currentCard === 'amex' ? 58 : 52)}}
            placeholder={cvc.placeholder}
            placeholderChar={cvc.placeholderChar}
            mask={cvc.mask}
            size={cvc.size}
            data-stripe='cvc'
            onChange={(e) => {e.target.value}}/>
        </div>
        {this.renderActions()}
      </form>
    )
  }

  renderSavedCardForm () {
    const cardBrand = this.props.currentCustomer.getIn(['card', 'brand'], 'Visa')
    const last4 = this.props.currentCustomer.getIn(['card', 'last4'])
    const placeholder = (
      cardBrand === 'American Express'
      ? ('**** ****** *' + last4)
      : ('**** **** **** ' + last4)
    )

    return (
      <div className='saved-credit-card-form' style={{marginTop: 20}}>
        <h4>{placeholder}</h4>
        <p style={{marginBottom: 20}}>Payment will be done using this card.</p>
        <div className='form-section'>
          <button className={this.props.submitButtonClasses} onClick={this.onSavedCardSubmit}>Checkout</button>
          <a href="#" style={{display: 'block', marginTop: 20}} onClick={this.onSwitchCurrentCard}>Pay with another card</a>
        </div>
      </div>
    )
  }

  renderBody () {
    if (this.props.currentCustomer && this.props.currentCustomer.get('customerId') && !this.state.shouldEnterNewCard) {
      return this.renderSavedCardForm()
    }
    else {
      return this.renderCardForm()
    }
  }

  render () {
    return (
      <div>
        <div className='information-line'>
          {this.renderInformation()}
        </div>
        {this.renderBody()}
      </div>
    )
  }
}

CreditCardForm.defaultProps = {
  onCheckoutComplete: () => {},
  submitButtonClasses: 'submit button success block'
}

const mapStateToProps = (state) => {
  return {
    currentPayoutRequest: state.get('currentPayoutRequest'),
    currentCustomer: state.get('currentCustomer')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    sendPayoutRequest: (ownProps.sendPayoutRequest || sendPayoutRequest),
    submitLaterSessionSideEffects: (ownProps.setLaterSessionSideEffects || setLaterSessionSideEffects),
    submitImmediateSessionSideEffects: (ownProps.setImmediateSessionSideEffects || setImmediateSessionSideEffects),
    watchCurrentPayoutRequest: watchCurrentPayoutRequest,
    unwatchCurrentPayoutRequest: unwatchCurrentPayoutRequest
  }
}

const CreditCardFormContainer = connect(
  mapStateToProps, mapDispatchToProps
)(CreditCardForm)

export default CreditCardFormContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/credit_card_form.js
 **/